import type { Fetcher } from '@remix-run/react'
import type { AvailableDeliveryWindow, Sla, SlaFormatedDate } from '~/type/Cart'

export interface IFormatDateTime {
  startHour: string
  startMinutes: string
  endHour: string
  endMinutes: string
  isToday: boolean
  dayOfWeek: string
  isTomorrow: boolean
  day: string
  month: string
  monthOfYear: string
  year: number
  completDate: string
}

export const formatDateTime = (startDate: string, endDate?: string): IFormatDateTime => {
  const daysOfWeek = [
    'domingo',
    'segunda-feira',
    'terça-feira',
    'quarta-feira',
    'quinta-feira',
    'sexta-feira',
    'sábado',
  ]
  const monthsOfYear = [
    'janeiro',
    'fevereiro',
    'março',
    'abril',
    'maio',
    'junho',
    'julho',
    'agosto',
    'setembro',
    'outubro',
    'novembro',
    'dezembro',
  ]

  const start = new Date(startDate)
  const end = new Date(endDate || '')

  const today = new Date()
  const tomorrow = new Date(today)
  tomorrow.setDate(today.getDate() + 1)

  const isToday =
    start.getUTCFullYear() === today.getUTCFullYear() &&
    start.getUTCMonth() === today.getUTCMonth() &&
    start.getUTCDate() === today.getUTCDate()

  const isTomorrow =
    start.getUTCFullYear() === tomorrow.getUTCFullYear() &&
    start.getUTCMonth() === tomorrow.getUTCMonth() &&
    start.getUTCDate() === tomorrow.getUTCDate()

  const dayOfWeek = daysOfWeek[start.getUTCDay()]
  const day = start.getUTCDate().toString().padStart(2, '0')
  const monthOfYear = monthsOfYear[start.getUTCMonth()]
  const month = (start.getUTCMonth() + 1).toString().padStart(2, '0')

  const year = start.getUTCFullYear()

  const startHour = start.getUTCHours().toString().padStart(2, '0')
  const startMinutes = start.getUTCMinutes().toString().padStart(2, '0')
  const endHour = end.getUTCHours().toString().padStart(2, '0')
  const endMinutes = end.getUTCMinutes().toString().padStart(2, '0')

  const completDate = start.toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    timeZone: "UTC",
  });

  return {
    startHour,
    startMinutes,
    endHour,
    endMinutes,
    isToday,
    dayOfWeek,
    isTomorrow,
    day,
    month,
    monthOfYear,
    year,
    completDate,
  }
}

export const filterUnique = <T>(
  array: T[] | undefined,
  comparator: (a: T, b: T) => boolean,
): T[] | undefined => {
  return array?.filter((item, index, self) => index === self.findIndex((t) => comparator(t, item)))
}

export const getHoursList = (widodws: AvailableDeliveryWindow[]): SlaFormatedDate[] => {
  return widodws.map(({ dateUtcFormated, ...params }) => {
    const { startHour, endHour } = dateUtcFormated!

    /**
     * Determina o período do dia com base na hora de início
     */
    const startHourNumber = parseInt(startHour, 10)
    let periodOfDay = ''

    if (startHourNumber >= 5 && startHourNumber < 12) {
      periodOfDay = 'Manhã'
    } else if (startHourNumber >= 12 && startHourNumber < 18) {
      periodOfDay = 'Tarde'
    } else {
      periodOfDay = 'Noite'
    }

    return { startHour, endHour, periodOfDay, ...params }
  }) as SlaFormatedDate[]
}

export const getMonthList = (sla: Sla) =>
  filterUnique(
    sla?.availableDeliveryWindows,
    (t, item) =>
      t.dateUtcFormated?.day === item.dateUtcFormated?.day &&
      t.dateUtcFormated?.month === item.dateUtcFormated?.month,
  )

export const generateUUIDv4 = () => {
  return crypto.randomUUID()
}

export const handleStateFetcherChange = ({
  fetcher,
  onIdle = () => { },
  onLoading = () => { },
  onSubmitting = () => { },
}: {
  onIdle?: () => void
  onLoading?: () => void
  onSubmitting?: () => void
  fetcher: Fetcher
}) => {
  const { state } = fetcher

  const stateHandlers: { [key in Fetcher['state']]: () => void } = {
    idle: onIdle,
    loading: onLoading,
    submitting: onSubmitting,
  }

  if (stateHandlers[state]) {
    stateHandlers[state]()
  }
}

/**
 * currency iso symbol (aka BRL)
 */
export function getStoreIsoCurrencySymbol() {
  return ((window.localeInfo || {}).CurrencyLocale || {}).ISOCurrencySymbol || 'BRL'
}

export function kebabCase(str: string) {
  return str
    .replace(/([a-z])([A-Z])/g, '$1-$2') // Add a dash between lowercase and uppercase letters
    .replace(/\s+/g, '-') // Replace spaces with dashes
    .replace(/_+/g, '-') // Replace underscores with dashes
    .toLowerCase() // Convert everything to lowercase
}

export const extractOfid = (cookies: string) => {
  const match = cookies.match(/checkout\.vtex\.com=__ofid=([a-zA-Z0-9]+)/)
  return match ? match[1] : null
}



export function formatPrice(valor: string | number) {
  const str = valor.toString();
  if (str.length <= 2) return '0,' + str.padStart(2, '0');
  return str.slice(0, -2) + ',' + str.slice(-2);
}
